var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-success btn--bigger",
                attrs: { type: "button" },
                on: { click: _vm.importar }
              },
              [
                _c("i", { staticClass: "fa fa-download" }),
                _c("span", [_vm._v("Importar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card__content" },
          [
            _c("k-table", {
              ref: "items",
              attrs: {
                path: _vm.path,
                editButton: _vm.puedeEditar,
                deleteButton: _vm.puedeAnular,
                createButton: _vm.puedeCrear,
                columns: [
                  {
                    display: "Código",
                    value: "codigo"
                  },
                  {
                    display: "Descripción",
                    value: "descripcion"
                  },
                  {
                    display: "Precio",
                    value: "precio",
                    numeric: true,
                    prefijo: "$"
                  },
                  {
                    display: "Costo",
                    value: "costo",
                    numeric: true,
                    prefijo: "$"
                  },
                  {
                    display: "Código de barra",
                    value: "codigo_barra"
                  },
                  {
                    display: "Creador",
                    value: "creador.nombre"
                  },
                  {
                    display: "Fecha de importación",
                    value: "created_at"
                  },
                  {
                    display: "Modificador",
                    value: "modificador.nombre"
                  },
                  {
                    display: "Modificación",
                    value: "updated_at"
                  }
                ]
              },
              on: {
                crear: _vm.crear,
                editar: _vm.editar,
                eliminar: _vm.eliminar
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            height: "auto",
            width: "75%",
            name: "edicionItem",
            scrollable: "",
            adaptive: "",
            reset: "",
            resizable: ""
          }
        },
        [
          _c("edicion-item", {
            attrs: {
              urlFoto: _vm.urlFoto,
              itemId: _vm.itemId,
              descripcionItem: _vm.descripcionItem
            },
            on: {
              preciosActualizados: _vm.preciosActualizados,
              uploaded: _vm.uploadedFoto,
              cerrar: function($event) {
                return _vm.$modal.hide("edicionItem")
              }
            },
            model: {
              value: _vm.selectedItem,
              callback: function($$v) {
                _vm.selectedItem = $$v
              },
              expression: "selectedItem"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Items")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22996b39", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22996b39","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/inventario/Items.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-22996b39","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/inventario/Items.vue
// module chunks = 0